import React, { Component } from 'react';
import Button from '../common/Button';
import { imageBasePath } from '../../constants/staticData';


export default class NotificationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        notificationSms : true,
        notificationEmail : true,
        marketEmail : true,
        motorEmail: true,
        submiteData: ''
        };
        this.onSubmit=this.onSubmit.bind(this);
        this.notificationUpdates=this.notificationUpdates.bind(this);

    }

    componentDidMount(){
    if(this.props.authReducer){
          this.notificationUpdates(this.props.userReducer.notificationRequests);
      }
    }

    componentWillUnmount() {
     this.props.actions.hideErrorMessage();
    }


    notificationUpdates(userReducer) {
        this.setState({
        notificationSms : userReducer.smsNotificationEnabled,
        notificationEmail : userReducer.emailNotificationEnabled,
        marketEmail : userReducer.marketingEmailsEnabled,
        motorEmail: userReducer.motoringNewsEmailsEnabled
        });
    }
    onSubmit(){
    let garageID=JSON.parse(localStorage.getItem('garage_id'));
       this.state.submiteData ={
            'garage_id' : garageID,
            'sms_notification_enabled': this.state.notificationSms,
            'email_notification_enabled': this.state.notificationEmail,
            'marketing_emails_enabled': this.state.marketEmail,
            'motoring_news_emails_enabled': this.state.motorEmail
        }
        this.props.actions.notificatioPreferenceUpdate(this.state.submiteData);
    }


    render() {
    const {authReducer} = this.props;
        return (
            <div>
              <div className="notification-form-info">
              <div className="notification-header-type">
              <img src={`${imageBasePath}/Email.svg`} className="notication-header-icon"/>Emails</div>
                <div className="notification-slab row">
                  <div className="notification-text col-xs-4">Get Notifications Through Email</div>
                  <div className="col-sm-6">
                  <label className="switch">
                    <input type="checkbox" onChange={()=>this.setState({ notificationEmail: this.state.notificationEmail ? false : true })} checked={this.state.notificationEmail}/>
                    <span className="slider"></span>
                  </label>
                  </div>
                </div>
                <div className="notification-slab row">
                  <div className="notification-text col-sm-4">Get Marketing Emails</div>
                  <div className="col-sm-6">
                  <label className="switch">
                    <input type="checkbox" onChange={()=>this.setState({ marketEmail: this.state.marketEmail ? false : true })} checked={this.state.marketEmail}/>
                    <span className="slider"></span>
                  </label>
                  </div>
                </div>
                <div className="notification-slab row">
                  <div className="notification-text col-sm-4">Get Motoring news email</div>
                  <div className="col-sm-6">
                  <label className="switch">
                    <input type="checkbox"  onChange={()=>this.setState({ motorEmail: this.state.motorEmail ? false : true })}  checked={this.state.motorEmail} />
                    <span className="slider"></span>
                  </label>
                  </div>
                </div>
                <div  className="notification-header-type">
                <img src={`${imageBasePath}/SMS.svg` } className="notication-header-icon"/>SMS</div>
                <div className="notification-slab row">
                <div className="notification-text col-sm-4">Get Notifications Through SMS</div>
                <div className="col-sm-6">
                  <label className="switch">
                    <input type="checkbox" onChange={()=>this.setState({ notificationSms: this.state.notificationSms ? false : true })} checked={this.state.notificationSms}/>
                    <span className="slider"></span>
                  </label>
                </div>
                  <div className="form-group bottom-controls visible-xs">
                    <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">
                      <div className="row visible-xs">
                        <div className="col-xs-6 add-veh-mob">
                          <Button
                            btnType="label"
                            btnSize="sm"
                            fontSize={16}
                            label="Save"
                            btnCallBack={() => this.onSubmit(this)}
                            customClass="btn-theme-save add-vehcile-save-btn"
                          />
                        </div>
                        <div className="col-xs-6 add-veh-mob  hidden-xs">
                          <Button
                            btnType="label"
                            btnSize="sm"
                            fontSize={16}
                            label="Cancel"
                            btnCallBack={() => window.history.back()}
                            customClass="btn-theme add-vehcile-cancel-btn"
                          />
                        </div>
                      </div>
                    </div>

                  </div>
              </div>
              </div>
              <div className="navigation-footer-part clearfix container add-vehcile-mob-wrapper">
                <Button btnType="label" btnSize="sm" fontSize={16} label="Save"  btnCallBack={()=>this.onSubmit(this)} customClass="btn-theme-save hidden-xs"/>


              </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UserAccounts/NotificationComponent.jsx